<header class="top" id="top">
  <div class="top__inner">
    <a class="brand" href="#top" (click)="$event.preventDefault(); scrollTo('top')" aria-label="Timesta">
      <img src="assets/images/timesta_real_logo_white.png" width="260" height="40" alt="Timesta" decoding="async" />
    </a>

    <div class="nav__links">
        <a class="nav__link" href="#" (click)="$event.preventDefault(); scrollTo('support')">{{ c.nav.support }}</a>
        <a class="nav__link" href="#" (click)="$event.preventDefault(); scrollTo('download')">{{ c.nav.download }}</a>
        <a class="nav__link" href="#" (click)="$event.preventDefault(); scrollTo('shots')">{{ c.nav.screens }}</a>
        <a class="nav__link" href="#" (click)="$event.preventDefault(); scrollTo('features')">{{ c.nav.features }}</a>
      </div>

    <div class="nav__right">
        <a class="nav__action" href="#" (click)="$event.preventDefault(); goPortal('login')">{{ c.nav.login }}</a>
        <a class="nav__action nav__action--primary" href="#" (click)="$event.preventDefault(); goPortal('register')">{{ c.nav.registration }}</a>
        <label class="lang" [attr.aria-label]="c.nav.language">
          <select class="lang__select" [ngModel]="lang" (ngModelChange)="setLang($event)" [ngModelOptions]="{standalone: true}">
            <option *ngFor="let option of langOptions" [ngValue]="option.code">{{ option.label }}</option>
          </select>
        </label>
      </div>
  </div>
</header>

<main class="landing">
  <section class="hero" aria-label="Hero">
    <div class="hero__bg" aria-hidden="true">
      <img
        src="assets/images/hero_photo_1024.webp"
        srcset="assets/images/hero_photo_640.webp 640w, assets/images/hero_photo_1024.webp 1024w, assets/images/hero_photo_1440.webp 1440w, assets/images/hero_photo_1920.webp 1920w"
        sizes="100vw"
        width="1920"
        height="820"
        alt=""
        class="hero__photo"
      />
      <img
        src="assets/images/hero_bokeh_1024.webp"
        srcset="assets/images/hero_bokeh_640.webp 640w, assets/images/hero_bokeh_1024.webp 1024w, assets/images/hero_bokeh_1440.webp 1440w, assets/images/hero_bokeh_1920.webp 1920w"
        sizes="100vw"
        width="1920"
        height="820"
        alt=""
        class="hero__bokeh"
      />
      <div class="hero__shade"></div>
    </div>

    <div class="hero__inner">
      <div class="hero__copy">
        <img class="hero__logo" src="assets/images/timesta_real_logo_white.png" width="480" height="74" alt="Timesta" decoding="async" />
        <p class="hero__lead">{{ c.hero.lead }}</p>

        <div class="stores">
          <button type="button" class="store" (click)="onDownload('appstore')">
            <span class="store__icon" aria-hidden="true"><img src="assets/svg/apple.svg" width="18" height="18" alt="" /></span>
            <span class="store__text">{{ c.hero.appStore }}</span>
          </button>
          <button type="button" class="store" (click)="onDownload('googleplay')">
            <span class="store__icon" aria-hidden="true"><img src="assets/svg/googleplay.svg" width="18" height="18" alt="" /></span>
            <span class="store__text">{{ c.hero.googlePlay }}</span>
          </button>
        </div>
      </div>

      <div class="hero__device" aria-hidden="true">
        <img
          src="assets/images/hero_phone_attached_20260321.png"
          width="1299"
          height="2048"
          alt=""
          class="hero__phone"
        />
      </div>
    </div>
  </section>

  <section class="concept" id="concept">
    <div class="container concept__inner">
      <div class="concept__copy">
        <h2 class="h2">{{ c.concept.title }}</h2>
        <p class="p">{{ c.concept.body }}</p>
        <a class="btn btn--ghost" href="#" (click)="$event.preventDefault(); scrollTo('features')">{{ c.concept.cta }}</a>
      </div>
      <div class="concept__art" aria-hidden="true">
        <img src="assets/images/concept_map.webp" srcset="assets/images/concept_map.webp 1x, assets/images/concept_map_2x.webp 2x" width="380" height="261" alt="" decoding="async" />
      </div>
    </div>
  </section>

  <section class="mission" id="mission">
    <div class="mission__bg" aria-hidden="true"></div>
    <div class="container mission__inner">
      <div class="mission__truck" aria-hidden="true">
        <img src="assets/images/truck.webp" srcset="assets/images/truck.webp 1x, assets/images/truck_2x.webp 2x" width="476" height="352" alt="" decoding="async" />
        <div class="mission__road" aria-hidden="true"></div>
      </div>
      <div class="mission__copy">
        <h2 class="h2 h2--light">{{ c.mission.title }}</h2>
        <p class="p p--light">{{ c.mission.body }}</p>
        <a class="btn btn--outline-light" href="#" (click)="$event.preventDefault(); scrollTo('features')">{{ c.mission.cta }}</a>
      </div>
    </div>
  </section>

  <section class="shots" id="shots">
    <div class="container shots__inner">
      <div class="shots__viewport" [attr.aria-label]="c.shots.aria">
        <div class="shots__slide"
             *ngFor="let shot of shotSources; let i = index"
             [class.shots__slide--active]="i === activeShot"
             [class.shots__slide--left]="isPrevShot(i)"
             [class.shots__slide--right]="isNextShot(i)"
             [class.shots__slide--hidden]="!isPrevShot(i) && !isNextShot(i) && i !== activeShot"
             (click)="goShot(i)">
          <img
            [src]="shot.src"
            [srcset]="shot.srcset"
            width="260"
            height="520"
            [alt]="c.shots.items[i]"
            class="shots__img"
          />
        </div>
      </div>

      <div class="dots" [attr.aria-label]="c.shots.aria">
        <button type="button" class="dot" *ngFor="let shot of shotSources; let i = index" [class.dot--on]="activeShot===i" (click)="goShot(i)" [attr.aria-label]="c.shots.slideLabel + ' ' + (i + 1)"></button>
      </div>
    </div>
  </section>

  <section class="features" id="features">
    <div class="container features__inner">
      <div class="features__copy">
        <h2 class="h2">{{ c.features.title }}</h2>
        <ul class="list">
          <li>{{ c.features.items[0] }}</li>
          <li>{{ c.features.items[1] }}</li>
          <li>{{ c.features.items[2] }}</li>
        </ul>
      </div>
      <div class="features__art" aria-hidden="true">
        <img src="assets/images/features_iso.webp" srcset="assets/images/features_iso.webp 1x, assets/images/features_iso_2x.webp 2x" width="560" height="380" alt="" decoding="async" />
      </div>
    </div>
  </section>

  <section class="download" id="download" aria-label="Download">
    <div class="download__bg" aria-hidden="true">
      <img
        src="assets/images/download_photo_1024.webp"
        srcset="assets/images/download_photo_640.webp 640w, assets/images/download_photo_1024.webp 1024w, assets/images/download_photo_1440.webp 1440w, assets/images/download_photo_1920.webp 1920w"
        sizes="100vw"
        width="1920"
        height="680"
        alt=""
        class="download__photo"
      />
      <div class="download__shade"></div>
    </div>

    <div class="download__inner">
      <h2 class="download__title">{{ c.download.title }}</h2>
      <div class="stores stores--center">
        <button type="button" class="store store--outline" (click)="onDownload('appstore')">
          <span class="store__icon" aria-hidden="true"><img src="assets/svg/apple.svg" width="18" height="18" alt="" /></span>
          <span class="store__text">{{ c.hero.appStore }}</span>
        </button>
        <button type="button" class="store store--outline" (click)="onDownload('googleplay')">
          <span class="store__icon" aria-hidden="true"><img src="assets/svg/googleplay.svg" width="18" height="18" alt="" /></span>
          <span class="store__text">{{ c.hero.googlePlay }}</span>
        </button>
      </div>
    </div>
  </section>

  <section class="support" id="support">
    <div class="container support__inner">
      <h2 class="support__title">{{ c.support.title }}</h2>
      <p class="support__email"><a href="mailto:support@timesta.com">support@timesta.com</a></p>

      <form class="support__card" [formGroup]="supportForm" (ngSubmit)="onSubmitSupport()" novalidate>
        <div class="support__messageWrap">
          <textarea class="support__message" rows="6" formControlName="message" [placeholder]="c.support.message"></textarea>
          <span class="field__err support__err" *ngIf="supportForm.controls.message.touched && supportForm.controls.message.invalid">{{ c.support.invalidMessage }}</span>
        </div>
        <button class="btn btn--primary support__send" type="submit">{{ c.support.send }}</button>
        <div class="support__art" aria-hidden="true">
          <img src="assets/images/envelope.webp" width="640" height="600" alt="" decoding="async" />
        </div>
      </form>

      <p class="footer">Timesta © 2018</p>
    </div>
  </section>
</main>
